import React, {useState, useEffect} from "react";
import {Box, Center, VStack, useBreakpointValue,Flex, HStack, Text, Link, Tooltip, ButtonGroup} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {Link as RouterLink} from "react-router-dom"
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import { Fab } from "@mui/material";
import {IconButton} from '@mui/material'
import GithubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X'


const Footer = () => {

// Creating a visible up icon upon scroll up
let [scrollingUp, setScrollingUp] = useState(true)
let [initialScroll, setInitialscroll] = useState(0)
  
    useEffect((e) => {

      let handleScroll = () => {
        let verticalScroll = window.scrollY
        
        setScrollingUp(verticalScroll < initialScroll)
        setInitialscroll(verticalScroll)
      }
      
      document.addEventListener("scroll", handleScroll)
      
      return () => {
        document.removeEventListener("scroll", handleScroll)
      }
    })

  
    
    let mobileView = useBreakpointValue({
      base: true,
      md: false
    })
  

  
    let style = {
    position: "fixed",
    bottom: "0",
    marginBottom: mobileView? 20 :10
  }



  
  return (
    <Box backgroundColor="#18181b" maxWidth="full">
      <footer style={{paddingBottom:40}}>
        <Flex
          margin="0 auto"
          px={ mobileView? 4:12}
          color="white"
          justifyContent="center"
          alignItems="center"
          maxWidth="1024px"
          //height={16}
          paddingTop={5}  //10   Alt:5
          paddingBottom={2} // 7  Alt:2
        >
        {/*  <p>Ben • © 2023</p> */}
        {!mobileView &&<Box flex="1"></Box>}
         <Box>
         <Text fontSize={["sm", "md"]}>© 2025 Ben. All rights reserved.</Text> 
         </Box>
         
         
        <Box flex="1" fontSize={mobileView&& "x-small"}  textAlign="right"  mt={-4}  >
        <ButtonGroup>
        <Tooltip label="Github" boxShadow= "0 8px 16px rgba(0,0,0,0.5)">
        <IconButton color="inherit" size="small" href="https://github.com/asenso95" aria-label="GitHub" sx={{ alignSelf: 'center', color:"white" }} target="_blank" rel="noopener noreferrer">
          <GithubIcon />
        </IconButton>
        </Tooltip>

        <Tooltip label="Twitter" boxShadow= "0 8px 16px rgba(0,0,0,0.5)">
        <IconButton color="inherit" size="small" href="https://x.com/ararat_ben" aria-label="X" sx={{ alignSelf: 'center', color:"white"}} target="_blank" rel="noopener noreferrer" >
          <XIcon />
        </IconButton>
        </Tooltip>

        <Tooltip label="Linkedin" boxShadow= "0 8px 16px rgba(0,0,0,0.5)">
        <IconButton color="inherit" size="small" href="https://www.linkedin.com/in/benasenso/" aria-label="LinkedIn" sx={{ alignSelf: 'center', color:"white" }} target="_blank" rel="noopener noreferrer" >
          <LinkedInIcon />
        </IconButton>
        </Tooltip>
        </ButtonGroup>

        </Box>
                

        </Flex>

        <VStack  mb={-4} color="white" px={mobileView? 5:12} >
        <Center>
        <Text textAlign="center" fontSize="small" color="gray.300">
          This site is protected by reCAPTCHA and the Google <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" textDecoration="underline" cursor="pointer" _active={{bg: "rgba(34,167,240,0.5)"}}>Privacy Policy</Link> and <Link href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" textDecoration="underline" cursor="pointer" _active={{bg: "rgba(34,167,240,0.5)"}}>Terms of Service</Link> apply.
        </Text>
        </Center>

        </VStack>   

        {(scrollingUp && window.scrollY>90) && 
          <Fab size="medium" color="secondary" sx={{border: "4px solid white", boxShadow:"0,0,25px, rgba(0.7)", position:"fixed", right:"3%", bottom:"3%", zIndex:5}} onClick={(e)=>{
            window.scrollTo({
              top:0,
              behavior:"smooth"
            })
          }} >
          <ArrowUpwardIcon fontSize="large" />
          </Fab> }
        
        {/* {(scrollingUp && window.scrollY>20) &&
        <Box box-shadow="md"  >
        <HStack justifyContent="end" paddingRight={20} >


      <div class="iconbutton">
        <a onClick={(e)=>{
          window.scrollTo({
            top: 0,
            behaviour: true
          })

        }}>

        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" width="63px">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        
        </a>
      </div>



        </HStack>
        </Box>} */}
      </footer>
    </Box>
  );
};
export default Footer;
